import * as React from "react";
/**
 * This icon from MDL2 is not available in @fluentui/react-icons
 * So we have to create the react icon component ourselves
 */ export const PortfolioLogo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: "url(#paint0_linear_936_112601)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.40039 7.2C4.40039 6.09543 5.29582 5.2 6.40039 5.2H8.06902C8.38728 5.2 8.6925 5.32643 8.91755 5.55147L10.0004 6.63431L8.35186 8.28284C8.27685 8.35785 8.17511 8.4 8.06902 8.4H4.40039V7.2ZM4.40039 9.2V12.8C4.40039 13.9046 5.29582 14.8 6.40039 14.8H13.6004C14.705 14.8 15.6004 13.9046 15.6004 12.8V8.8C15.6004 7.69543 14.705 6.8 13.6004 6.8H10.9661L8.91755 8.84853C8.6925 9.07357 8.38728 9.2 8.06902 9.2H4.40039Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_936_112601",
        x1: "19.5833",
        y1: "1.10362e-06",
        x2: "-4.58333",
        y2: "25",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#3FBBFA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#9668F8"
    }))));
